if (!customElements.get('details-disclosure')) {
  class DetailsDisclosure extends HTMLElement {
    constructor() {
      super();

      this.mainDetailsToggle = this.querySelector('details');
      if (!this.mainDetailsToggle) return;

      this.summary = this.mainDetailsToggle.querySelector('summary');
      this.isClosing = false;
      this.closeAnimationDuration = 350;

      this.onKeyUp = this.onKeyUp.bind(this);
      this.onFocusOut = this.onFocusOut.bind(this);

      this.addEventListener('keyup', this.onKeyUp);
      this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut);
    }

    onKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      const openDetailsElement = event.target.closest('details[open]');
      if (!openDetailsElement) return;

      const disclosure = openDetailsElement.closest('details-disclosure');
      if (!disclosure) return;

      disclosure.close(true);
    }

    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) {
          this.close(false);
        }
      });
    }

    close(focusSummary = false) {
      if (!this.mainDetailsToggle || !this.mainDetailsToggle.hasAttribute('open')) return;
      if (this.isClosing) return;

      this.isClosing = true;
      this.mainDetailsToggle.setAttribute('closing', '');

      window.setTimeout(() => {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.removeAttribute('closing');
        this.isClosing = false;

        if (focusSummary && this.summary) {
          this.summary.focus();
        }
      }, this.closeAnimationDuration);
    }
  }

  customElements.define('details-disclosure', DetailsDisclosure);
}